// src/routes/public.routes.tsx
import type { ReactElement } from 'react'
import { lazy } from 'react'
import {
  APP_ROUTES_FORGOT_PASSWORD,
  APP_ROUTES_INVITATION,
  APP_ROUTES_LANDING,
  APP_ROUTES_LOGIN,
  APP_ROUTES_PUBLIC_REGISTER,
  APP_ROUTES_RESET_PASSWORD,
  APP_ROUTES_UNLOCK_ACCOUNT
} from '../constants'
import {
  APP_ROUTE_PATIENT_FORGOT_PASSWORD,
  APP_ROUTE_PATIENT_INVITATION,
  APP_ROUTE_PATIENT_RESET_PASSWORD,
  APP_ROUTE_PATIENT_VERIFICATION
} from '../constants/patientRoutes'

const Login = lazy(() => import('@pages/Authentication/Login'))
const InvitePage = lazy(() => import('@pages/Authentication/Invitation'))
const ForgotPassword = lazy(() => import('@pages/Authentication/ForgotPassword'))
const ResetPassword = lazy(() => import('@pages/Authentication/ResetPassword'))
const UnlockAccount = lazy(() => import('@pages/Authentication/UnlockAccount'))
const Landing = lazy(() => import('@pages/Landing'))
const PatientForgotPage = lazy(() => import('@pages/Authentication/ForgotPassword/PatientForgetPassword'))
const PatientInvitePage = lazy(() => import('@pages/Authentication/Invitation/PatientInvite'))
const PatientResetPasswordPage = lazy(() => import('@pages/Authentication/ResetPassword/PatientResetPassword'))
const PatientVerificationPage = lazy(() => import('@pages/Authentication/ResetPassword/Verification'))
const PublicRegisterForm = lazy(() => import('@/src/pages/Public/RegisterForm'))

export type RouteConfig = {
  path: string
  element: ReactElement
  permissionKey?: string | string[]
}

export const publicRoutes: RouteConfig[] = [
  { element: <Login />, path: APP_ROUTES_LOGIN },
  { element: <InvitePage />, path: APP_ROUTES_INVITATION },
  { element: <ForgotPassword />, path: APP_ROUTES_FORGOT_PASSWORD },
  { element: <ResetPassword />, path: APP_ROUTES_RESET_PASSWORD },
  { element: <UnlockAccount />, path: APP_ROUTES_UNLOCK_ACCOUNT },
  { element: <Landing />, path: APP_ROUTES_LANDING },
  { element: <PublicRegisterForm />, path: APP_ROUTES_PUBLIC_REGISTER },
  { element: <PatientForgotPage />, path: APP_ROUTE_PATIENT_FORGOT_PASSWORD },
  { element: <PatientInvitePage />, path: APP_ROUTE_PATIENT_INVITATION },
  { element: <PatientResetPasswordPage />, path: APP_ROUTE_PATIENT_RESET_PASSWORD },
  { element: <PatientVerificationPage />, path: APP_ROUTE_PATIENT_VERIFICATION }
]
